import { render } from "./share-modal-users.vue?vue&type=template&id=27521eb7&scoped=true&ts=true"
import script from "./share-modal-users.vue?vue&type=script&lang=ts"
export * from "./share-modal-users.vue?vue&type=script&lang=ts"

import "./share-modal-users.vue?vue&type=style&index=0&id=27521eb7&lang=scss&scoped=true"
import "./share-modal-users.vue?vue&type=style&index=1&id=27521eb7&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27521eb7"]])

export default __exports__